import React from "react";
import type { InstructorCourse } from "services/instructorCoursesService";

export type CourseCounts = {
  folders?: number;
  items?: number;
  quizzes?: number;
  announcements?: number;
};

export type CourseContextValue = {
  course: InstructorCourse;
  reload: () => Promise<void>;
  counts: CourseCounts;
  setCounts: (next: Partial<CourseCounts>) => void;
};

const CourseContext = React.createContext<CourseContextValue | null>(null);

export function CourseProvider({
  value,
  children,
}: {
  value: CourseContextValue;
  children: React.ReactNode;
}) {
  return <CourseContext.Provider value={value}>{children}</CourseContext.Provider>;
}

export function useCourse(): CourseContextValue {
  const ctx = React.useContext(CourseContext);
  if (!ctx) throw new Error("useCourse must be used within a CourseProvider");
  return ctx;
}
